import React from "react";
import QuoteForm from "@/components/QuoteForm";
import { Phone, Sparkles, Building2, Home, Boxes } from "lucide-react";

export default function Cleaning() {
  return (
    <div data-testid="cleaning-page">
      <section className="hb-hero-frame text-white py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="text-xs tracking-[0.35em] uppercase text-white/60 mb-4">Hampton Blu Creations · A Division of</div>
          <h1 className="font-display text-6xl sm:text-7xl">Hampton Blu Cleaning Services</h1>
          <p className="mt-6 text-2xl font-serif-editorial italic text-white/90">A Cleaner Space, the Right Way.</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-16">
        <p className="text-lg leading-relaxed text-neutral-800">
          Hampton Blu Cleaning Services proudly provides reliable, professional cleaning solutions for residential homes, apartments, offices, and small businesses. We are committed to delivering dependable service, attention to detail, and exceptional results with every visit.
        </p>
        <p className="mt-6 text-lg leading-relaxed text-neutral-800">
          Whether you need recurring cleaning, deep cleaning, move-in/move-out services, or office cleaning, we're here to help.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            {icon: Home, t: "Residential"},
            {icon: Building2, t: "Commercial"},
            {icon: Sparkles, t: "Deep Cleaning"},
            {icon: Boxes, t: "Move-In / Move-Out"},
          ].map(({icon: Icon, t}) => (
            <div key={t} className="bg-white border border-neutral-200 p-6 text-center">
              <Icon size={28} className="mx-auto mb-3 text-[color:var(--hb-royal)]"/>
              <div className="text-sm font-medium">{t}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 pb-24">
        <div className="mb-6">
          <div className="text-xs tracking-widest uppercase text-neutral-500 mb-2">Get in touch</div>
          <h2 className="font-display text-4xl text-[color:var(--hb-navy)]">Request a Cleaning Quote</h2>
          <p className="mt-3 text-neutral-700">
            For all cleaning inquiries or to schedule a service, please contact <b>Deborah</b> at{" "}
            <a href="tel:6313529877" className="underline inline-flex items-center gap-1"><Phone size={14}/> 631-352-9877</a>{" "}
            or use the form below.
          </p>
        </div>
        <QuoteForm
          serviceType="cleaning"
          contactPerson="Deborah"
          contactPhone="631-352-9877"
          defaultServiceOptions={[
            "Recurring Cleaning","Deep Cleaning","Move-In / Move-Out Cleaning",
            "Office / Commercial Cleaning","Post-Construction Cleaning","Other"
          ]}
        />
      </section>
    </div>
  );
}
